import { render } from "./LinkToStory.vue?vue&type=template&id=52c61040&scoped=true"
import script from "./LinkToStory.vue?vue&type=script&lang=js"
export * from "./LinkToStory.vue?vue&type=script&lang=js"

import "./LinkToStory.vue?vue&type=style&index=0&id=52c61040&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-52c61040"
/* hot reload */
if (module.hot) {
  script.__hmrId = "52c61040"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52c61040', script)) {
    api.reload('52c61040', script)
  }
  
  module.hot.accept("./LinkToStory.vue?vue&type=template&id=52c61040&scoped=true", () => {
    api.rerender('52c61040', render)
  })

}

script.__file = "src/components/LinkToStory.vue"

export default script